import { Component, OnInit, Inject, ViewChild, OnDestroy, ElementRef, HostListener, Injector } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Subject, combineLatest } from 'rxjs';
import { Observable } from 'rxjs';
import * as fromStore from './store';
import { UsersState } from './store/reducers/user.reducers';
import { filter, map, switchMap, takeUntil } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';import { DOCUMENT } from "@angular/common";
import { isODM, environment } from '../environments/environment';
import * as fromFeature from './my-features';
import { AutoLogoutService } from './services/auto-logout-service.service';
import { LangList, PackageList, urlPath, OAuthPurposeType, updateInfoType, OAuthPlatformType, PROStatusLockAuthTypeIndex } from './shareModel';
import { WindowService } from './services/window.service';
import { BtyReplacementParams } from './my-features/battery-replacement/battery-replacement.model';
import { UpdateInfoModel } from './my-features/updateInfo/update-info.model';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './services/language.service';
import { NavigationEnd, Router, ActivatedRoute, NavigationCancel, NavigationStart } from '@angular/router';
import { OauthExchangeParam, OauthLoginParam, AccountOauthSWParam } from './my-features/account/oauth.model';
import { TinyColor } from '@ctrl/tinycolor';
import { RegionService } from './services/region.service';
import { ToastMessageOptions as Message, MessageService } from 'primeng/api';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UserService } from '../app/services/user.service';
import { UtilsService } from './services/utils.service';
import { User } from './models/user';
import {EventMonitoringFilter, EventsParams, FilterParams} from './models/events';
import html2canvas from 'html2canvas';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})

export class AppComponent implements OnInit, OnDestroy {
  @ViewChild('LockedContent', { static: false }) targetDiv!: ElementRef;
  private componentDestroyed = new Subject();
  proLock = {
    Lock: false,
    Block: false,
    AuthType: -1,
    PayNow: false
  };
  title = 'PowerPanelCloud';
  reset = false;
  isLogIn = false;
  shareModel = {
    PackageList: PackageList,
    urlPath: urlPath
  };
  powerMaster = isODM;
  hostName: string;
  pageTitle: string;
  CopyrightYear = new Date().getFullYear();
  currentURL: string;
  showSideBar: Boolean = true;
  showRouter: Boolean = true;
  mainContentMargin = false;
  isUserModuleData = true;
  access_token: string;
  code: string;
  userEmail: string;
  jwt: string;

  mainColor = '#007ad9';
  selectDefaultMode = 'Default';
  mainColorLight: any;
  mainColorDark: any;
  bgdefault = '#f1f3f7';
  bgheader = '#ffffff';
  primaryColor = [
    { name: 'text', color: 'rgba(127, 204, 255, 0.1)', darkContrast: true },
    { name: 'text', color: '#007ad9', darkContrast: false },
    { name: 'text', color: '#0062a2', darkContrast: false },
  ];
  mainColorText = false;
  mainColorDarkText = false;
  UpdateInfoParam = {} as UpdateInfoModel;
  curDate = new Date();
  filterParam: EventMonitoringFilter = {
    // device_status: 2,
    startDate: new Date(this.curDate.getTime() - 24 * 60 * 60 * 1000 * 3),
    endDate: new Date()
  };
  // filterMsp = false;
  AccountInfoIsRead = false; // 控制ClientAccountInfo只讀取一次
  AccountManagementInfoIsRead = false; // 控制AccountsInfo只讀取一次
  DeviceInfoIsRead = false; // 控制非msp帳號的設備相關api只讀取一次
  AllModuleIsRead = false; // 控制AllModule指讀取一次
  showCanvas = false;
  canvasImg: any;
  resizeTimeout: any;
  getMspRegionParam = {
    otp: '',
    RegionId: []
  };
  paymentSettingLoad= false;
  currnUser: any;
  isSystemAdmin = false;
  isAdmin = false;
  isPro = false;

  constructor(
    // tslint:disable-next-line: deprecation
    @Inject(DOCUMENT) private doc,
    private autoLogout: AutoLogoutService, private store: Store<fromStore.State>,
    private titleService: Title, private windowService: WindowService,
    private injector: Injector,
    private languageService: LanguageService,
    private router: Router,
    private route: ActivatedRoute,
    private regionService: RegionService,
    private ngxService: NgxUiLoaderService,
    private messageService: MessageService,
    private userService: UserService,
    private utils: UtilsService) {

    // 設定固定兩秒將提示視窗關閉
    const originalAdd = this.messageService.add.bind(this.messageService);
    this.messageService.add = (message: Message) => {
      originalAdd(message);
      setTimeout(() => {
        this.messageService.clear();
      }, 2000);
    };

    // Initial
    this.store.select(fromStore.getIsLogin).subscribe(res => {
      if (res) {
        // this.store.dispatch(new fromFeature.GetClientAccount());
        this.store.dispatch(new fromFeature.GetRegions());
        // this.store.dispatch(new fromFeature.GetAllAccounts());
        this.store.dispatch(new fromStore.GetUserModules());
        // this.store.dispatch(new fromFeature.GetFloorMaps());
        this.store.dispatch(new fromFeature.GetNodes({ nodes: null }));
        // this.store.dispatch(new fromFeature.GetChangeInfosAction());
        this.store.dispatch(new fromStore.GetEventMaps());
        this.store.dispatch(new fromFeature.GetPackages());
        this.store.dispatch(new fromStore.GetHardwareFaultCodes());
        this.store.dispatch(new fromStore.GetHardwareFaultLevels());
        this.store.dispatch(new fromFeature.GetBatteryReplacements({} as BtyReplacementParams));
        this.store.dispatch(new fromFeature.GetCountrys());
        // this.store.dispatch(new fromFeature.GetWorldMaps());
        // this.store.dispatch(new fromFeature.GetMspMemberRegions());
        this.store.dispatch(new fromFeature.GetPreferences());
        if (!isODM) {
          this.store.dispatch(new fromFeature.LoadPrices());
          this.store.dispatch(new fromFeature.GetPlanSettings());
        }
        // this.filterMsp = false;
      } else {
        this.AccountInfoIsRead = false;
        this.AccountManagementInfoIsRead = false;
        this.DeviceInfoIsRead = false;
        this.AllModuleIsRead = false;
      }
    });

    combineLatest(this.store.select(fromStore.getCurrentUser), this.store.select(fromStore.DevicesFilteredLoaded))
    .pipe(takeUntil(this.componentDestroyed)).subscribe(([user, Loaded]) => {
      if (user.isLogin && !user.isLoading && user.isLoaded) {
        const currentUrl = this.router.url;
        if (user.authority && user.authority > 0) {
          if (!this.AccountManagementInfoIsRead) {
            if (currentUrl.startsWith('/' + urlPath['Admin Settings']) || currentUrl.startsWith('/' + urlPath['AccountManagement']) ||
                currentUrl.startsWith('/' + urlPath['DeviceMgtList']) || currentUrl.startsWith('/' + urlPath['LicenseMgtList'])) {
                  this.store.dispatch(new fromFeature.GetAllAccounts());
                  this.AccountManagementInfoIsRead = true;
            } else {
              if (Loaded) {
                this.store.dispatch(new fromFeature.GetAllAccounts());
                this.AccountManagementInfoIsRead = true;
              }
            }
          }
        } else {
          if (!this.AccountManagementInfoIsRead && !this.AccountInfoIsRead) {
            this.AccountInfoIsRead = true;
            this.store.dispatch(new fromFeature.GetClientAccount());
          }
          // this.store.dispatch(new fromFeature.GetClientAccount());
        }
        if (!this.AllModuleIsRead) {
          if (!currentUrl.startsWith('/' + urlPath['Package'])) {
            if (Loaded) {
              // this.store.dispatch(new fromFeature.GetModules({ modules: null }));
              this.store.dispatch(new fromFeature.GetModulesByRegion());
              this.AllModuleIsRead = true;
            }
          }
        }
      }
    });

    this.store.pipe(select(fromStore.getCurrentUser)).subscribe((res) => {
      this.isLogIn = res.isLogin;
      if (!res.isLogin) {
        const body = document.getElementsByTagName('body')[0];
        body.classList.add('body-login');
      }
      // login read account info by authority
      // if (res.isLogin && !res.isLoading && res.isLoaded) {
      //   if (res.authority && res.authority > 0) {
      //     if (!this.AccountManagementInfoIsRead) {
      //       setTimeout(() => {
      //         this.store.dispatch(new fromFeature.GetAllAccounts());
      //       }, 10000);
      //       this.AccountManagementInfoIsRead = true;
      //     }
      //   } else {
      //     if (!this.AccountManagementInfoIsRead && !this.AccountInfoIsRead) {
      //       this.AccountInfoIsRead = true;
      //       this.store.dispatch(new fromFeature.GetClientAccount());
      //     }
      //     // this.store.dispatch(new fromFeature.GetClientAccount());
      //   }
      //   // const currentUrl = this.router.url;
      //   // console.log(currentUrl, res);
      //   // if (currentUrl.startsWith('/' + urlPath['Login'])) {
      //   //   console.log('login');
      //   // } else if (currentUrl.startsWith('/' + urlPath['Admin Settings']) || currentUrl.startsWith('/' + urlPath['AccountManagement'])
      //   //         || currentUrl.startsWith('/' + urlPath['DeviceMgtList']) || currentUrl.startsWith('/' + urlPath['LicenseMgtList'])) {
      //   //   if (!this.AccountManagementInfoIsRead) {
      //   //     console.log('management');
      //   //     this.AccountManagementInfoIsRead = true;
      //   //     if (!currentUrl.startsWith('/' + urlPath['AccountManagement'])) {
      //   //       this.store.dispatch(new fromFeature.GetAllAccounts());
      //   //     }
      //   //   }
      //   // } else {
      //   //   if (!this.AccountManagementInfoIsRead && !this.AccountInfoIsRead) {
      //   //     console.log('else');
      //   //     this.AccountInfoIsRead = true;
      //   //     this.store.dispatch(new fromFeature.GetClientAccount());
      //   //   }
      //   // }
      // }
      // sso logout hide <router-outlet>
      if (!res.isLogin && !res.isLoading && res.isLoaded) {
        const token = JSON.parse(this.utils.getToken());
        const ssouser = (token && token.ssouser) ? token.ssouser : '';
        if (ssouser) {
          if (token.ssocookie) {
            this.showRouter = false;
          }
        }
      }
    });

    combineLatest(this.store.select(fromStore.getIsMsp), this.store.select(fromStore.getCurrentUser)).pipe(takeUntil(this.componentDestroyed))
    .subscribe(([getIsMspRes, getCurrentUserRes]) => {
      if ((getIsMspRes !== undefined && getIsMspRes !== null) &&
      (getCurrentUserRes !== undefined && getCurrentUserRes !== null)) {
        this.isSystemAdmin = getCurrentUserRes.authority === 2;
        this.isAdmin = getCurrentUserRes.authority === 1;
        this.currnUser = getCurrentUserRes;
        this.isPro = getIsMspRes;
        if (this.isSystemAdmin || this.isAdmin) {
          let mspRegionParam = this.getMspRegionParam;
          if (!this.isSystemAdmin) {
            mspRegionParam = {
              ...this.getMspRegionParam,
              RegionId: [getCurrentUserRes.RegionId]
            };
          }
            this.store.dispatch(new fromFeature.GetMspRegionPayment(mspRegionParam))
        }

        const param = {
          otp: ""
        } as any
        if (getIsMspRes) {
          param.RegionId = getCurrentUserRes.RegionId
          this.store.dispatch(new fromFeature.GetMspMemberRegions());
        }
        this.store.dispatch(new fromFeature.GetSmartPowerReportList(param));
      }
    });

    this.store.select(fromStore.getPROStatusLock).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res.isLoaded) {
        this.proLock.Lock = res.Lock;
        this.proLock.AuthType = res.AuthType;
        this.SetProLock();
      }
    });

    // 統一更新 DevicesStatus DeviceInfo Groups
    this.store.select(fromStore.getMspRegionFilter).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res !== null) {
        if (res.isMsp && res.filterLoaded) {
          const param = { regionIds: res.selectedId };
          const UserParam = { regionIds: res.selectedId } as User;
          this.store.dispatch(new fromStore.GetDevicesStatusAction(UserParam));
          this.store.dispatch(new fromStore.GetDeviceInfoAction(param));
          this.store.dispatch(new fromStore.GetGroups(param));
          this.store.dispatch(new fromFeature.GetSummary({RegionIds: res.selectedId}));
        } else if (!res.isMsp && !this.DeviceInfoIsRead) {
          this.store.dispatch(new fromStore.GetDevicesStatusAction());
          this.store.dispatch(new fromStore.GetDeviceInfoAction());
          this.store.dispatch(new fromStore.GetGroups());
          if (!isODM) {
            this.store.dispatch(new fromFeature.GetSummary());
          }
          this.DeviceInfoIsRead = true;
        }
      }
    });

    // Get Title, ThemeColor, Logo
    // this.pageTitle = this.regionService.GetLogoPath;
    this.mainColor = this.regionService.GetThemeColorCode;
    this.selectDefaultMode = this.regionService.GetSelectDefaultMode;
    this.savethem();

    // Get Host Name
    this.hostName = window.location.hostname;
    // this.hostName = this.windowService.getHostName();

    // Get Region Info
    this.store.select(fromStore.getRegions).subscribe(res => {
      if (res !== undefined && res != null) {
        let region = res.find(i => i.Region.toLowerCase() === this.hostName.toLowerCase());
        if (res.length > 0) {
          const mspMainRegionId = res[0].MspMainRegionId; // 只為取母公司RegionId
          if (mspMainRegionId !== undefined && mspMainRegionId == this.currnUser.RegionId && !this.paymentSettingLoad) {
            this.store.dispatch(new fromFeature.GetMspRegionPayment({ ...this.getMspRegionParam }))
            this.paymentSettingLoad = true;
          }
        }
        
        const title = (region) ? region.RegionName : null;
        if (!!title) {
          this.pageTitle = title;
          if (res.length > 0) {
            region = this.windowService.getLogoRegion(res);
            if (typeof region !== 'undefined' && region !== null) {
              this.regionService.SetLogoPath = region.RegionName;
              this.regionService.SetThemeColorCode = region.ThemeColorCode;
              this.regionService.SetSelectDefaultMode = region.Appearance;
              this.pageTitle = region.RegionName;
              this.mainColor = region.ThemeColorCode;
              this.selectDefaultMode = region.Appearance;
            }

            // this.pageTitle = (typeof region !== 'undefined' && region !== null) ? region.RegionName : '';
            // this.mainColor = (typeof region !== 'undefined' && region !== null) ? region.ThemeColorCode : '#007ad9';
            // this.selectDefaultMode = (typeof region !== 'undefined' && region !== null) ? region.Appearance : 'Default';

            // const region = res.find(i => i.Domain != null && i.Domain.toLowerCase().includes(this.hostName.toLowerCase()));
            // const title = (region) ? region.RegionName : null;
            // if (!!title) {
            //   this.pageTitle = title;
            // }
            // this.mainColor = region !== undefined ? region.ThemeColorCode : '#db0000';
            // this.selectDefaultMode = region !== undefined ? region.Appearance : 'Default';
            this.savethem();
          }
        }
      }
    });
  if (this.userService.GetRedirect === ('/' + urlPath['FirmwareMgt']) || this.userService.GetRedirect === ('/' + urlPath['MacSnMgt'])
   || this.userService.GetRedirect === ('/' + urlPath['ApiDocument'])
   || (this.userService.GetRedirect && this.userService.GetRedirect.startsWith('/' + urlPath['mobilePurchasePlan']))
   || this.userService.GetRedirect === ('/' + urlPath['FirmwareRMCMgt'])) {
    this.mainContentMargin = true;
  }
    // Get Current Route Path
    router.events.subscribe((event) => {
      // event-summary 頁面 在剛切換plan時沒有取及時的usermodule有可能會取到舊的plan
      // 但如果constructor不呼叫API頁面又會卡住 故在此NavigationStart時再呼叫一次
      if (event instanceof NavigationStart) {
        if (event.url.startsWith('/event-summary')) {
          const moduleParam = {force: true};
          this.store.dispatch(new fromStore.GetUserModules(moduleParam));
        }
      }
      if (event instanceof NavigationEnd) {
        if (event.url.startsWith('/add-device')) {
          this.showSideBar = false;
        } else if (event.url === ('/' + urlPath['FirmwareMgt']) || event.url === ('/' + urlPath['MacSnMgt'])
         || event.url === ('/' + urlPath['ApiDocument']) || event.url.startsWith('/' + urlPath['mobilePurchasePlan'] )
         || event.url === (urlPath['ApiTermsofuse']) || event.url === ('/' + urlPath['FirmwareRMCMgt'])) {
          this.mainContentMargin = true;
        } else if (event.url.startsWith('/help') ) {
          this.showSideBar = false;
        } else if (event.url.startsWith('/confirm-companion')) {
          this.showSideBar = false;
        } else if (event.url.startsWith('/' + urlPath['ApiTermsofuse'])) {
          this.showSideBar = false;
          this.mainContentMargin = true;
        } else if (event.url.startsWith('/' + urlPath['ProUpgrade'])) {
          this.showSideBar = false;
          this.mainContentMargin = false;
        } else {
          this.showSideBar = true;
          this.mainContentMargin = false;
        }
        this.currentURL = event.url;
        this.SetProLock();
      }
    });


    // Reset the Event Language Translate.
    // this.translateService.onLangChange.asObservable().subscribe((res) => {
    //     this.store.dispatch(new fromStore.ChangeLanguageEventMaps());
    //     this.store.dispatch(new fromStore.ChangeLanguageFaultCodes());
    // });

    this.store.select(fromStore.getIsUserModuleData)
      .subscribe(res => {
        if (!res.isLoading) {
          this.isUserModuleData = res.isLoaded;
        }
      });
      router.events.subscribe(s => {
        if (s instanceof NavigationCancel) { // page: login 因login頁使用時無登入憑證 所以會執行頁面跳轉回login頁 所以會進入這裡
          // console.log(s.url.split('#')[0]);
          // console.log(s.url.split('#')[1]);
          const param: OauthExchangeParam = {
            Purpose: OAuthPurposeType.LoginOauth
          };
          if (s.url.indexOf('?') !== -1) {
            const params = new URLSearchParams(s.url.split('?')[1]);
            // 2026/07/21 kyrie.hung 移除 Facebook 登入功能
            // this.code = params.get('code');
            // if (this.code) {
            //   this.ngxService.start();
            //   param.Code = this.code;
            //   param.Redirect_Url = environment.HomePageUrl;
            //   this.store.dispatch(new fromFeature.GetFacebookAccessToken(param));
            // }
            // apple
            const appleUser = params.get('appleuser');
            if (appleUser) {
              this.ngxService.start();
              const decodeuser = decodeURIComponent(atob(appleUser));
              const user = JSON.parse(decodeuser);
              this.userEmail = user.email;
              const appleId = user.id;
              const firstname = user.firstname;
              const lastname = user.lastname;

              const loginParam: OauthLoginParam = {
                Platform: OAuthPlatformType.Apple,
                PId: appleId,
                Email: this.userEmail,
                WithDevice: true,
                Code: '',
                FirstName: (firstname) ? firstname : this.userEmail.split('@')[0],
                LastName: (lastname) ? lastname : '',
                Purpose: OAuthPurposeType.LoginOauth
              };
              this.store.dispatch(new fromFeature.GetOauthLogin(loginParam));
            }

          } else {
            // Google
            const params = new URLSearchParams(s.url.split('#')[1]);
            this.access_token = params.get('access_token');
            if (this.access_token) {
              this.ngxService.start();
              param.Access_token = this.access_token;
              this.store.dispatch(new fromFeature.GetExchangeGoogleUserInfo(param));
            }

          }
        }
        if (s instanceof NavigationEnd) { // page: account-info, sw-social-login : account-info有登入憑證 , sw-social-login沒有擋auth
          const param: OauthExchangeParam = {
            Purpose: OAuthPurposeType.AddOauth
          };
          if (s.url.indexOf('?') !== -1) {
            const params = new URLSearchParams(s.url.split('?')[1]);
            const param_platform = params.get('platform');
            let param_state = params.get('state');
            if (param_platform && param_state) { // sw social login - sw呼叫時進入 有platform與state參數
              const platform = parseInt(param_platform, 10);
              const decodestate = decodeURIComponent(atob(param_state));
              const state = JSON.parse(decodestate);
              const obj = {
                time: state.time,
                uid: state.uid,
                app: state.app
              };
              if (platform === OAuthPlatformType.Apple) {
                let url = environment.PowerPanelCloudAppleOAuthUrl.replace('{0}', environment.RedirectAuthApiUrl);
                url = url.replace('{1}', '&state=' + btoa(encodeURIComponent(JSON.stringify(obj))));
                window.location.href = url;
              }
              if (platform === OAuthPlatformType.Google) {
                let url = environment.PowerPanelCloudGoogleOAuthUrl.replace('{0}', environment.HomePageUrl + 'login/social/sw');
                url = url.replace('{1}', '&state=' + btoa(encodeURIComponent(JSON.stringify(obj))));
                window.location.href = url;
              }
              // 2026/07/21 kyrie.hung 移除 Facebook 登入功能
              // if (platform === OAuthPlatformType.Facebook) {
              //   let url = environment.PowerPanelCloudFacebookOAuthUrl.replace('{0}', environment.HomePageUrl + 'login/social/sw');
              //   url = url.replace('{1}', '&state=' + btoa(encodeURIComponent(JSON.stringify(obj))));
              //   window.location.href = url;
              // }
            } else {
              // 2026/07/21 kyrie.hung 移除 Facebook 登入功能
              // this.code = params.get('code');
              // if (this.code) {
              //   if (param_state) {
              //     if (param_state.indexOf('#') !== -1) { param_state = param_state.split('#')[0]; }
              //     const decodestate = decodeURIComponent(atob(param_state));
              //     const state = JSON.parse(decodestate);
              //     param.app = state.app;
              //     param.time = state.time;
              //     param.uid = state.uid;
              //     param.Purpose = OAuthPurposeType.LoginOauthBySW;
              //     param.Redirect_Url = environment.HomePageUrl + 'login/social/sw';
              //   } else {
              //     param.Purpose = OAuthPurposeType.AddOauth;
              //     param.Redirect_Url = environment.HomePageUrl + 'account-info';
              //   }
              //   param.Code = this.code;
              //   this.store.dispatch(new fromFeature.GetFacebookAccessToken(param));
              // }
              // apple
              const appleUser = params.get('appleuser');
              if (appleUser) {
                const decodeuser = decodeURIComponent(atob(appleUser));
                const user = JSON.parse(decodeuser);
                const appleId = user.id;
                this.userEmail = user.email;
                if (param_state) { // sw-social-login
                  const decodestate = decodeURIComponent(atob(param_state));
                  const state = JSON.parse(decodestate);
                  const firstname = user.firstname;
                  const lastname = user.lastname;

                  const loginParam: OauthLoginParam = {
                    Platform: OAuthPlatformType.Apple,
                    PId: appleId,
                    Email: this.userEmail,
                    WithDevice: true,
                    Code: '',
                    FirstName: (firstname) ? firstname : this.userEmail.split('@')[0],
                    LastName: (lastname) ? lastname : '',
                    app: state.app,
                    time: state.time,
                    uid: state.uid,
                    Purpose: OAuthPurposeType.LoginOauthBySW,
                  };
                  this.store.dispatch(new fromFeature.GetOauthLogin(loginParam));
                } else { // account-info
                  const loginParam: OauthLoginParam = {
                    Platform: OAuthPlatformType.Apple,
                    PId: appleId,
                    Email: this.userEmail,
                    WithDevice: true,
                    Code: '',
                    Purpose: OAuthPurposeType.AddAccountFromWeb
                  };
                  this.store.dispatch(new fromFeature.AddAccountOauth(loginParam));
                }
              }
            }
          } else {
            // Google
            const params = new URLSearchParams(s.url.split('#')[1]);
            this.access_token = params.get('access_token');
            if (this.access_token) {
              param.Access_token = this.access_token;
              const param_state = params.get('state');
              if (param_state) { // sw social login - google輸入完帳號確認身分後進入
                const decodestate = decodeURIComponent(atob(param_state));
                const state = JSON.parse(decodestate);
                param.app = state.app;
                param.time = state.time;
                param.uid = state.uid;
                param.Access_token = this.access_token;
                param.Purpose = OAuthPurposeType.LoginOauthBySW;
                this.store.dispatch(new fromFeature.GetExchangeGoogleUserInfo(param));
              } else { // ppc social login
                this.store.dispatch(new fromFeature.GetExchangeGoogleUserInfo(param));
              }
            }
          }
        }
      });

      this.store.select(fromStore.getUpdateInfoState).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res.type === updateInfoType.LoginOAuth) {
        if (!res.isLoading && res.isLoaded) {
          if (res.isSaved) {
            this.messageService.add({ severity: 'success',
             summary: this.injector.get(TranslateService).instant('You have logged in with the social account successfully!') });
          } else if (!res.isSaved) {
            // tslint:disable-next-line:max-line-length
            this.messageService.add({ severity: 'error',
             summary: this.injector.get(TranslateService).instant('An error occurs when loging in to your social account. Please try again later.') });
          }
          this.ngxService.stop();
        }
        this.resetUpdateInfoState();
      }
      // 2026/07/21 kyrie.hung 移除 Facebook 登入功能
      // if (res.type === updateInfoType.FacebookOAuthLogin) {
      //   if (!res.isLoading && res.isLoaded) {
      //     if (!res.isSaved) {
      //       this.messageService.add({ severity: 'error',
      //        summary: this.translateService.instant('An error occurs when loging in to your social account.') });
      //     }
      //   }
      // }
    });
  }

  ngOnInit() {
    // 💡 延遲初始化語言服務，確保 TranslateService 已完全準備好
    setTimeout(() => {
      this.languageService.initializeTranslation();
    }, 100);
    
    const body = document.getElementsByTagName('body')[0];
    // @ts-ignore
    if (!isODM) {
      this.titleService.setTitle('PowerPanelCloud');
      body.classList.add('body-Cloud');
      document
        .getElementById('appFavicon')
        .setAttribute('href', '/assets/favicon.ico');
    } else {
      this.titleService.setTitle(this.pageTitle);
      body.classList.add('body-ODM');
      document
        .getElementById('appFavicon')
        .setAttribute('href', 'data:image/x-icon;,');
        // this.savethem();
    }
  }

  SetProLock() {
    this.proLock.PayNow = (this.currentURL && this.currentURL.startsWith('/' + urlPath['ProManagementCompany']) && this.proLock.AuthType === PROStatusLockAuthTypeIndex.EndUserAccountManager) ? true : false;
    if (this.proLock.Lock && !this.proLock.PayNow) {
      this.proLock.Block = true;
      this.toggleToContent();
      setTimeout(() => {
        this.toggleToCanvas();
      }, 1000);
      setTimeout(() => {
        const body = document.getElementsByTagName('body')[0];
        body.classList.remove('body-unlock');
        body.classList.add('body-locked');
      }, 1500);
    } else {
      this.toggleToContent();
      this.proLock.Block = false;
      const body = document.getElementsByTagName('body')[0];
      body.classList.remove('body-unlock');
      body.classList.remove('body-locked');
    }
  }

  // 利用 getter 處理顯示邏輯
  get isLockDialogVisible(): boolean {
    return this.isLogIn && this.proLock.Block;
  }

  // 利用 setter 處理關閉時的回寫邏輯
  set isLockDialogVisible(value: boolean) {
    if (!value) {
      // 當彈窗嘗試關閉（傳回 false）時，我們只更新 Block 狀態
      this.proLock.Block = false;
    }
  }

  toggleToCanvas() {
    if (!this.isLogIn || (this.proLock.AuthType === 2 && this.router.url === '/management/pro/company')) {
      return;
    }

    const element = this.targetDiv.nativeElement;
    html2canvas(element).then(canvas => {
      this.canvasImg = canvas.toDataURL('image/png');
      this.showCanvas = true;
      this.ngxService.stop();
    });
  }

  toggleToContent() {
    this.showCanvas = false;
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-unlock');
    body.classList.remove('body-locked');
  }

  savethem() {
    this.mainColorLight = new TinyColor(this.mainColor)
    .lighten(37)
    .setAlpha(0.1)
    .toString();
    this.mainColorDark = new TinyColor(this.mainColor).darken(6).toString();
    document.documentElement.style.setProperty('--bg-default', this.bgdefault);
    document.documentElement.style.setProperty('--bg-header', this.bgheader);
    document.documentElement.style.setProperty(
      '--primary-color',
      this.mainColor
    );
    document.documentElement.style.setProperty(
      '--primary-color-dark',
      this.mainColorDark
    );
    document.documentElement.style.setProperty(
      '--primary-color-light',
      this.mainColorLight
    );

    this.mainColorText = new TinyColor(this.mainColor).isLight();
    if (this.mainColorText) {
      document.documentElement.style.setProperty(
        '--primary-color-text',
        '#000000'
      );
    } else {
      document.documentElement.style.setProperty(
        '--primary-color-text',
        '#ffffff'
      );
    }

    this.mainColorDarkText = new TinyColor(this.mainColorDark).isLight();
    if (this.mainColorDarkText) {
      document.documentElement.style.setProperty(
        '--primary-color-dark-text',
        '#000000'
      );
    } else {
      document.documentElement.style.setProperty(
        '--primary-color-dark-text',
        '#ffffff'
      );
    }

    const body = document.getElementsByTagName('body')[0];

    if (this.selectDefaultMode === 'Default') {
      body.classList.add('default');
      body.classList.remove('light');
      body.classList.remove('dark');
    } else if (this.selectDefaultMode === 'Light') {
      body.classList.remove('default');
      body.classList.add('light');
      body.classList.remove('dark');
    } else if (this.selectDefaultMode === 'Dark') {
      body.classList.remove('default');
      body.classList.remove('light');
      body.classList.add('dark');
    }
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    if (this.proLock.Lock) {
      this.toggleToContent();
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        if (this.proLock.Block) {
          this.toggleToCanvas();
          const body = document.getElementsByTagName('body')[0];
          body.classList.remove('body-unlock');
          body.classList.add('body-locked');
        }
      }, 500);
    }
  }


  logout() {
    this.store.dispatch(new fromStore.LogoutAction());
    this.userService.SetRedirect = null;
    this.ngxService.start();
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }
}


